import { observer } from 'mobx-react-lite'
import Typography, { TypographyProps } from '@mui/material/Typography'
import useStore from 'reusable/mobx-store-utils'
import Avatar from '@mui/material/Avatar'
import { getShortName } from "reusable/utils/avatar-utils"
import { SxProps } from '@mui/material/styles'
import PersonIcon from '@mui/icons-material/Person';
import { documentWorkspaceThemeConfig } from 'theme/documentWorkspaceTheme'
import { themeConfig }from '@gap/shared/theme'
import { usePdfStore } from 'reusable/pdf/PdfStore'

interface IAvatarWithName {
   name?: string
   sx?: SxProps
   typographySx?: SxProps
   small?: boolean
   variant?: TypographyProps['variant']
   disabled?: boolean
}

/**
 * Return Avatar with name in the correct Typography. It automaticly shortens the name(if not done already) and if no name was found it will display a personIcon
 */
export default observer(function AvatarWithName({ name, sx, small, variant, typographySx, disabled }: IAvatarWithName) {
   const { isGeneratingPdf } = usePdfStore()

   const localStore = useStore(
      sp => ({
         get name() {
            if (!sp.name || !sp.name.length) {
               return undefined
            }
            return getShortName(sp.name)
         },
      }),
      { name }
   )

   if (small) {
      sx = { ...sx, ...documentWorkspaceThemeConfig.sizes.avatar }
   }

   return (
      <Avatar sx={{ backgroundColor: themeConfig.primary[disabled ? 200 : 400], ...sx }}>
         {localStore.name && <Typography variant={variant || 'caption'} title={name} sx={{ mt: isGeneratingPdf ? '' : '2px', ...typographySx }}>{localStore.name}</Typography>}
         {!localStore.name && <PersonIcon fontSize="small" />}
      </Avatar>
   )
})
